import i18next from 'i18next';
import { StellantisQuoteStatus } from 'src/api/models/Enums';
import ToolTip from 'src/components/Tooltip/Tooltip';
import { formatDate } from 'src/utils';
import _ from 'lodash';
import { StellantisQuoteInfoTooltip, StellantisUtils } from 'src/components/Stellantis';

export const columnsData = [
  {
    id: 'requestDate',
    Header: i18next.t('requestDate'),
    minWidth: 290,
    accessor: 'requestDate',
    sortType: (a: any, b: any) => {
      return new Date(a.values.requestDate).getTime() - new Date(b.values.requestDate).getTime();
    },
    Cell: ({ row }) => {
      const rawDate = row?.original?.requestDate;
      if (!rawDate) return null;
      const formatted = formatDate(rawDate + "Z", 'it-IT', true);
      return formatted === 'Invalid Date' ? rawDate : formatted;
    },
  },
  {
    id: 'cliente',
    Header: i18next.t('customer'),
    accessor: (values) => {
      const tipoCliente = values.quote?.tipoCliente;
      return (tipoCliente == 'azienda'
        ? values.quote?.ragioneSociale
        : [values.quote?.nome, values.quote?.cognome].filter(Boolean).join(' '));
    },
    minWidth: 290,
    Cell: ({ row }) => {
      const elId = `info-customer-${row.id}`;
      const maxChars = 20;
      const tipoCliente = row?.original?.quote?.tipoCliente;

      const value = (tipoCliente == 'azienda'
        ? row?.original?.quote?.ragioneSociale
        : [row?.original?.quote?.nome, row?.original?.quote?.cognome].filter(Boolean).join(' '));

      const shouldTruncate = value?.length > maxChars;
      const computedValue = _.truncate(value, { 'length': maxChars });

      return (
        <div id={elId}>
          {computedValue}
          {shouldTruncate && <ToolTip
            anchorId={elId}
            content={value}
            className="w-75"
          />}
        </div>
      )
    },
  },
  {
    id: 'requestedBy',
    Header: i18next.t('sales'),
    disableSortBy: true,
    minWidth: 290,
    accessor: (values) => {
      return values.requestedByFullname || values.requestedBy;
    },
    Cell: ({ row }) => {
      const elId = `info-requestedBy-${row.id}`;
      const maxChars = 20;
      const value = (row?.original?.requestedByFullname || row?.original?.requestedBy);
      const shouldTruncate = value?.length > maxChars;
      const computedValue = _.truncate(value, { 'length': maxChars });

      return (
        <div id={elId}>
          {computedValue}
          {shouldTruncate && <ToolTip
            anchorId={elId}
            content={value}
            className="w-75"
          />}
        </div>
      )
    },
  },
  {
    accessor: 'quote.marca',
    id: 'marca',
    Header: i18next.t('marca'),
    width: 140,
  },
  {
    accessor: 'quote.modello',
    id: 'modello',
    Header: i18next.t('modello'),
    width: 140,
  },
  {
    accessor: 'quote.allestimento',
    id: 'allestimento',
    Header: i18next.t('allestimento'),
    width: 140,
    Cell: ({ row }) => {
      const elId = `info-allestimento-${row.id}`;
      const maxChars = 50;
      const value = row?.original?.quote?.allestimento || '';
      const shouldTruncate = value?.length > maxChars;
      const computedValue = _.truncate(value, { 'length': maxChars });

      return (
        <div id={elId} className='text-wrap' style={{ minWidth: 240 }}>
          {computedValue}
          {shouldTruncate && <ToolTip
            anchorId={elId}
            content={value}
            className="w-75"
          />}
        </div>
      )
    },
  },
  {
    id: 'canone',
    Header: i18next.t('rental_fee'),
    width: 140,
    Cell: ({ row }) => {
      const quoteRequest = row.original;
      if (!StellantisUtils.isQuoted(quoteRequest)) {
        return '___';
      }
      const value = quoteRequest.quote.canone;
      const ivaInfo = StellantisUtils.isPrivato(quoteRequest) ? i18next.t('vat_included') : i18next.t('vat_excluded');
      // const type = StellantisUtils.isPrivato(quoteRequest) ? 'Privato' : 'P.IVA/Azienda'
      return (
        <>
          {'€' + (value ?? 0)}
          <div><small className="text-muted">({ivaInfo?.toLowerCase()})</small></div>
        </>
      )
    }
  },
  {
    accessor: 'quote.provvigioni',
    id: 'provvigioni',
    Header: i18next.t('provvigioni'),
    width: 140,
    Cell: ({ row }) => {
      const quoteRequest = row.original;
      return '€' + (quoteRequest?.quote?.provvigioni ?? 0);
    }
  },
  {
    Header: i18next.t('other'),
    id: 'expander',
    Cell: ({ row }) => {
      return <StellantisQuoteInfoTooltip quoteRequest={row.original} type='quote' />
    },
  },
  {
    id: 'status',
    Header: i18next.t('state'),
    accessor: (values) => {
      return values.status ? i18next.t('quote_status_' + values.status?.toLowerCase()) : 'UNKNOWN';
    },
    minWidth: 120,
    Cell: ({ row }) => {
      const status = row.original?.status;

      if (StellantisUtils.isUnquotable(row.original)) {
        return <div className="fw-bold text-danger">
          {i18next.t('quote_status_' + status?.toLowerCase())}
        </div>
      }

      return (
        <span className={status === StellantisQuoteStatus.QUOTED ? 'fw-bold' : ''}>
          {status ? i18next.t('quote_status_' + status?.toLowerCase()) : 'UNKNOWN'}
        </span>
      )
    },
  },
  {
    accessor: 'actions',
    id: 'actions',
    Header: '',
    disableSortBy: true,
    width: 60,
  },
];
